import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useCallback, useMemo } from 'react';
import { EFormStep } from '../../../types';
export var useFormStep = function useFormStep(open) {
  var _useState = useState(open ? EFormStep.Form : EFormStep.Closed),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var openForm = useCallback(function () {
    setStep(EFormStep.Form);
  }, []);
  var closeModal = useCallback(function () {
    setStep(EFormStep.Closed);
  }, []);
  var showSuccess = useCallback(function () {
    setStep(EFormStep.Success);
  }, []);
  return useMemo(function () {
    return {
      step: step,
      openForm: openForm,
      closeModal: closeModal,
      showSuccess: showSuccess
    };
  }, [closeModal, openForm, showSuccess, step]);
};